<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Corporate Sales - Banner</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Name Banner"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-model="items.name"
              v-validate="'required'"
              name="name_banner"
              data-vv-as="Name Banner"
              id="input-1"
              class="form-control"
              placeholder="Name Banner"
            />
            <b-form-invalid-feedback id="input-name_banner-feedback">{{
              veeErrors.first("name_banner")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Foto Banner (Desktop):"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Foto Banner (Desktop)</b>
                  <sup class="text-secondary pl-3"
                    >(2 Mb)&nbsp;(1920px x 700px)</sup
                  >
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileDesktop"
                    name="imagedesktop"
                    data-vv-as="Foto Desktop"
                    v-validate="
                      !items.image_desktop_jpg
                        ? 'required|minimalDimensions:1920,700|ratiolDimensions:1920,700|size:2000|ext:jpg,png,gif,jpeg'
                        : 'minimalDimensions:1920,700|ratiolDimensions:1920,700|size:2000|ext:jpg,png,gif,jpeg'
                    "
                    style="display: none"
                    v-on:change="onChangeFileDesktop()"
                  />
                  <b-button
                    @click="$refs.fileDesktop.click()"
                    v-show="!items.image_desktop_jpg && !fileDesktop"
                    variant="primary"
                    class="ml-5"
                    >Pilih File</b-button
                  >
                  <b-button
                    v-show="items.image_desktop_jpg || fileDesktop"
                    variant="primary"
                    @click="modalDesktop = !modalDesktop"
                    class="mr-2"
                    >Pratinjau</b-button
                  >
                  <b-button
                    @click="$refs.fileDesktop.click()"
                    v-show="items.image_desktop_jpg || fileDesktop"
                    variant="outline-primary"
                    class
                    >Ubah File</b-button
                  >
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imagedesktop") }}
          </p>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label"
            class="required"
            label="Foto Banner (Mobile):"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>Foto Banner (Mobile)</b>
                  <sup class="text-secondary pl-3"
                    >(2 Mb)&nbsp;(640px x 600px)</sup
                  >
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="fileMobile"
                    name="imagemobile"
                    data-vv-as="Foto Mobile"
                    v-validate="
                      !items.image_mobile_jpg
                        ? 'required|minimalDimensions:640,600|ratiolDimensions:640,600|size:2000|ext:jpg,png,gif,jpeg'
                        : 'minimalDimensions:640,600|ratiolDimensions:640,600|size:2000|ext:jpg,png,gif,jpeg'
                    "
                    style="display: none"
                    v-on:change="onChangeFileMobile()"
                  />
                  <b-button
                    @click="$refs.fileMobile.click()"
                    v-show="!items.image_mobile_jpg && !fileMobile"
                    variant="primary"
                    class="ml-5"
                    >Pilih File</b-button
                  >
                  <b-button
                    v-show="items.image_mobile_jpg || fileMobile"
                    variant="primary"
                    @click="modalMobile = !modalMobile"
                    class="mr-2"
                    >Pratinjau</b-button
                  >
                  <b-button
                    @click="$refs.fileMobile.click()"
                    v-show="items.image_mobile_jpg || fileMobile"
                    variant="outline-primary"
                    class
                    >Ubah File</b-button
                  >
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width: 100%; margin-top: 0.25rem; font-size: 80%"
          >
            {{ veeErrors.first("imagemobile") }}
          </p>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Heading (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-model="items.heading.id"
              v-validate="'required'"
              name="heading_id"
              data-vv-as="Heading Bahasa"
              id="input-1"
              class="form-control"
              placeholder="Heading In Bahasa Indonesia"
            />
            <b-form-invalid-feedback id="input-heading_id-feedback">{{
              veeErrors.first("heading_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Heading (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.heading.en"
              name="heading_en"
              data-vv-as="Heading English"
              class="form-control"
              placeholder="Heading In English"
            />
            <b-form-invalid-feedback id="input-heading_en-feedback">{{
              veeErrors.first("heading_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Sub Heading (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-model="items.sub_heading.id"
              v-validate="'required'"
              name="sub_heading_id"
              data-vv-as="Sub Heading Bahasa"
              id="input-1"
              class="form-control"
              placeholder="Sub Heading In Bahasa Indonesia"
            />
            <b-form-invalid-feedback id="input-sub_heading_id-feedback">{{
              veeErrors.first("sub_heading_id")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Sub Heading (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="'required'"
              v-model="items.sub_heading.en"
              name="sub_heading_en"
              data-vv-as="Sub Heading English"
              class="form-control"
              placeholder="Sub Heading In English"
            />
            <b-form-invalid-feedback id="input-sub_heading_en-feedback">{{
              veeErrors.first("sub_heading_en")
            }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <b-form-group
            id="fieldset-1"
            label="Dengan Tombol"
            label-for="input-1"
          >
            <b-form-radio-group
              id="radio-group-1"
              v-model="items.is_with_button"
              :options="options1"
              name="radio-options"
            ></b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="items.is_with_button">
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Teks Tombol (Bahasa)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="items.is_with_button ? 'required' : ''"
              v-model="items.button_text.id"
              name="button_text_id"
              data-vv-as="Teks Tombol Bahasa"
              class="form-control"
              placeholder="Teks Tombol Bahasa"
            />
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("button_text_id") }}
            </p>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            id="fieldset-1"
            label="Teks Tombol (English)"
            label-class="control-label"
            class="required"
            label-for="input-1"
          >
            <input
              v-validate="items.is_with_button ? 'required' : ''"
              v-model="items.button_text.en"
              name="button_text_en"
              data-vv-as="Teks Tombol Bahasa"
              class="form-control"
              placeholder="Teks Tombol Bahasa"
            />
            <p
              class="text-danger"
              style="width: 100%; margin-top: 0.25rem; font-size: 80%"
            >
              {{ veeErrors.first("button_text_en") }}
            </p>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-show="items.is_with_button">
        <b-col md="12">
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="URL Tombol Desktop"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="
                    items.is_with_button
                      ? 'required|url: {require_protocol: true }'
                      : ''
                  "
                  v-model="items.button_url_desktop"
                  name="url_button_desktop"
                  data-vv-as="URL Tombol Desktop"
                  class="form-control"
                  placeholder="URL Tombol Desktop"
                />
                <p
                  class="text-danger"
                  style="width: 100%; margin-top: 0.25rem; font-size: 80%"
                >
                  {{ veeErrors.first("url_button_desktop") }}
                </p>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                id="fieldset-1"
                label="URL Tombol Mobile"
                label-class="control-label"
                class="required"
                label-for="input-1"
              >
                <input
                  v-validate="
                    items.is_with_button
                      ? 'required|url: {require_protocol: true }'
                      : ''
                  "
                  v-model="items.button_url_mobile"
                  name="url_button_mobile"
                  data-vv-as="URL Tombol Mobile"
                  class="form-control"
                  placeholder="URL Tombol Mobile"
                />
                <p
                  class="text-danger"
                  style="width: 100%; margin-top: 0.25rem; font-size: 80%"
                >
                  {{ veeErrors.first("url_button_mobile") }}
                </p>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <b-button
            variant="primary"
            :disabled="loading"
            @click="post()"
            class="mr-3"
            size="lg"
          >
            Update
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalMobile" title="Preview Image" size="xl">
      <img
        v-show="!fileMobile"
        v-if="items.image_mobile_jpg"
        width
        height="400px"
        :src="items.image_mobile_jpg"
      />
      <img
        v-show="fileMobile"
        v-if="urlMobile"
        width
        height="400px"
        :src="urlMobile"
      />
    </b-modal>
    <b-modal v-model="modalDesktop" title="Preview Image" size="xl">
      <img
        v-show="!fileDesktop"
        v-if="items.image_desktop_jpg"
        width
        height="400px"
        :src="items.image_desktop_jpg"
      />
      <img
        v-show="fileDesktop"
        v-if="urlDesktop"
        width
        height="400px"
        :src="urlDesktop"
      />
    </b-modal>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
      items: [],
      loading: false,
      section: "",
      type: null,
      heading_id: "",
      heading_en: "",
      sub_heading_id: "",
      sub_heading_en: "",
      content_id: "",
      content_en: "",
      widthImage: null,
      heightImage: null,
      urlImage: "",
      image: "",
      modalImage: false,
      modalMobile: false,
      modalDesktop: false,
      fileDesktop: "",
      fileMobile: "",
      urlMobile: "",
      urlDesktop: "",
      options1: [
        { text: "Tidak", value: false },
        { text: "Ya", value: true },
      ],
    };
  },
  beforeCreate() {
    this.$store.dispatch("CorpSalesBannerModule/getBanner");
  },
  created() {
    this.$store.watch(
      (state) => state.CorpSalesBannerModule.banner_id,
      (newValue, oldValue) => {
        this.items = newValue;
      }
    );
  },
  methods: {
    post() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("name", this.items.name);
          formData.append("heading_id", this.items.heading.id);
          formData.append("heading_en", this.items.heading.en);
          formData.append("sub_heading_id", this.items.sub_heading.id);
          formData.append("sub_heading_en", this.items.sub_heading.en);
          formData.append("image_desktop_jpg", this.fileDesktop);
          formData.append("image_mobile_jpg", this.fileMobile);
          formData.append("is_with_button", this.items.is_with_button);
          formData.append("button_text_id", this.items.button_text.id);
          formData.append("button_text_en", this.items.button_text.en);
          formData.append("button_url_desktop", this.items.button_url_desktop);
          formData.append("button_url_mobile", this.items.button_url_mobile);
          this.$store
            .dispatch("CorpSalesBannerModule/postBanner", formData)
            .then((response) => {
              this.loading = false;
              this.$validator.reset();
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500,
              });
              console.log(response);
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data,
                showConfirmButton: false,
                timer: 1500,
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal("ERROR!", "Your file cant be submit.", "warning");
        }
      });
    },
    onChangeFileDesktop() {
      this.fileDesktop = this.$refs.fileDesktop.files[0];
      const input = this.$refs.fileDesktop;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlDesktop = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
    onChangeFileMobile() {
      this.fileMobile = this.$refs.fileMobile.files[0];
      const input = this.$refs.fileMobile;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;
          this.urlMobile = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    },
  },
};
</script>

<style>
</style>
